import axios from './axios';

const API_URL = '/C4-Nicaragua/Utilerias'; // ajusta si usas otro endpoint"el nombre del archivo de route de backend 

export const getMonedas = async () => {
  try {
    const response = await axios.get(`${API_URL}/Monedas`);
   // console.log(response.data);
    return response.data;
  } catch (error) {
    console.error('Error al obtener monedas:', error);
    return [];
  }
};

export const getFormasPago = async () => {
  try {
   
    const response = await axios.get(`${API_URL}/FormaPago`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener formas de pago:', error);
    return [];
  }
};
export const getImpuestos = async () => {
  try {
   console.log(`${API_URL}/Impuestos`);
    const response = await axios.get(`${API_URL}/Impuestos`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener impuestos:', error);
    return [];
  }
};
export const getMediosPago = async () => {
  try {
   
    const response = await axios.get(`${API_URL}/MediosPago`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener medios de pago:', error);
    return [];
  }
};

export const getTipoCambioMoneda= async ({ monedaBase, monedaObjetivo }) => {
  try {
    
    const response = await axios.get(`${API_URL}/TipoCambio`, {  params: {monedaBase, monedaObjetivo} });
    //console.log(response);
    return response;
  }
  catch (error) {
    console.error('Error al obtener tipo de cambio', error);
    return error;
  }
};
